export default (state = {}, action) => {
  const { type, payload } = action;
  if (type === "SHOW_EDIT_RESULT") {
    const { show, matchId } = payload;
    return {
      ...state,
      editResultOpen: show,
      editResultMatchId: show ? matchId : null
    };
  } else if (type === "SHOW_PASSWORD_DIALOG") {
    const { show, matchId, action } = payload;
    return {
      ...state,
      passwordDialogOpen: show,
      passwordDialogMatchId: show ? matchId : null,
      passwordDialogAction: show ? action : null
    };
  } else if (type === "SHOW_TOAST_MESSAGE") {
    const message = payload;
    return {
      ...state,
      toastMessage: message
    };
  }
  return state;
};



// WEBPACK FOOTER //
// ./src/store/ui/uiReducer.js